<template>
    <div class="otp-dialog">
      <div class="otp-dialog-overlay"></div>
      <div class="otp-dialog-content">
        <p class="label">Please enter the One-Time Password (OTP) sent to your mail:</p>
        <input type="text" v-model="enteredOTP" placeholder="Enter OTP" />
        <button @click="onVerify">Verify</button>
        <button @click="onCancel">Cancel</button>
        <div class="error">{{ errorMessage }}</div>
      </div>
    </div>
</template>

<script>

export default ({
    name: "ForgotPasswordOTP",
    props: {
        errorMessage: String
    },
    data() {
        return {
            enteredOTP: '',
        }
    },
    methods: {
        onCancel() {
            this.$emit("cancelClicked")
        },
        onVerify() {
            this.$emit("resetPassword", this.enteredOTP);
        }
    }
})
</script>


<style scoped>
 .otp-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .otp-dialog-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  
  .otp-dialog-content {
    position: relative;
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1;
  }
  
  .otp-dialog-content h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .otp-dialog-content p {
    font-size: 16px;
    margin-bottom: 20px;
    font-family: Inter-Regular;
    font-weight: 600;
    line-height: 17px;
    color: #666666;
    margin-top: 16px;
  }
  
  input[type="text"] {
    width: 250px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
  
  button {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    background-color: #007bff;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
    margin-right: 10px;
  }
  
  button:hover {
    background-color: #0056b3;
  }
  
  button:focus {
    outline: none;
  }

  .content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
  }

  .error{
    font-family: Inter-Regular;
    font-size: 12px;
    color: #EB5757;
    text-align: left;
    margin-left: 24px;
  }
</style>